<template lang="pug">
img.image-base(@load='loadEvent')
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ImageBase extends Vue {
  private loadEvent(key: Event): void {
    this.$emit('load', key)
  }
}
</script>

<style lang="stylus" scoped></style>
